import React, { useCallback } from 'react'
import { LinkButton } from '@/atoms/Button'
import { FlexRow } from '@/atoms/FlexContainers'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { CaptionSM } from '@/atoms/Text'
import { Avatar } from '@/molecules/Avatar'
import { useShopifyMultipassForOrders } from '@/services/Shopify/hooks'
import { useUser } from '@/services/UserService'
import { useLoginUrl } from '@/utils/auth-utils'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

const GiveawayNav = () => {
  const { loginUrl, trackLoginStarted } = useLoginUrl()
  const { user } = useUser()
  const { t } = useTranslate('tickets')
  const { totalEntries } = useShopifyMultipassForOrders() ?? {}

  const onAccountClick = useCallback(() => {
    return window?.open('/account?t=myTickets', '_blank', 'noopener,noreferrer')
  }, [])

  return (
    <nav className="relative flex items-center justify-between">
      <AngelLogo color="white" height={32} />

      <FlexRow className="gap-4">
        {totalEntries && totalEntries > 0 ? (
          <a
            className="homestead-eyebrow-md rounded-md bg-homestead-yellow px-2 py-1 uppercase"
            href="/account?t=myTickets"
            target="_blank"
          >
            {totalEntries} {t('giveawayEntries', 'Entries')}
          </a>
        ) : null}

        {user ? (
          <div className="w-fit overflow-hidden rounded-full border-2 border-black bg-cover ring-2 ring-white">
            <Avatar onClick={onAccountClick} />
          </div>
        ) : (
          <div className="flex items-center">
            <LinkButton
              href={loginUrl}
              variant="white"
              outline
              className="box-border h-8 rounded-md backdrop-blur-sm"
              onClick={() => trackLoginStarted('top-nav')}
            >
              <CaptionSM className="whitespace-nowrap">
                <Translate t={t} i18nKey="logIn">
                  Log In
                </Translate>
              </CaptionSM>
            </LinkButton>
          </div>
        )}
      </FlexRow>
    </nav>
  )
}

export default GiveawayNav
